export default __webpack_public_path__ + "static/media/scenario.1fc0c021.png";